import { CardRow } from 'components/CardRow';
import { Icon, ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import {
  selectAseExplorerOptionSize,
  selectAseSection,
  selectAseTplSection,
} from 'store/assessments/selectors';
import { theme } from 'lib/theme';
import { View } from 'react-native';
import { ViewWithSeparators } from 'components/ViewWithSeparators';
import { CountChips } from '../CountChips';

interface Props {
  id: string;
  collapsible: boolean;
  collapsed: boolean;
  onToggleCollapsedPress: () => void;
  actionsCount: number;
  controlsCount: number;
  unreviewedActionsCount: number;
  unreviewedControlsCount: number;
}

export const ExplorerSectionRow: React.FC<Props> = ({
  collapsible,
  collapsed,
  id,
  onToggleCollapsedPress,
  actionsCount,
  controlsCount,
  unreviewedActionsCount,
  unreviewedControlsCount,
}) => {
  const template = useSelector((state) => selectAseTplSection(state, id));
  const result = useSelector((state) => selectAseSection(state, id));
  const hasComment = !!result?.comment;
  const explorerOptionSize = useSelector(selectAseExplorerOptionSize);

  const hasFindingsCount =
    !!actionsCount ||
    !!controlsCount ||
    !!unreviewedActionsCount ||
    !!unreviewedControlsCount;

  return (
    <CardRow
      icon={collapsible ? ICONS.ChevronRightLight : undefined}
      onIconPress={onToggleCollapsedPress}
      iconStyle={{ transform: [{ rotate: collapsed ? '0deg' : '90deg' }] }}
      childrenStyle={{ flexDirection: 'row', alignItems: 'center' }}
      style={{ backgroundColor: 'transparent' }}
      compact={explorerOptionSize === 'small'}
      small={explorerOptionSize === 'small'}
    >
      <Txt
        weight="bold"
        style={{ flex: 1 }}
        size={explorerOptionSize === 'small' ? 'xsmall' : undefined}
      >
        {template.name}
      </Txt>
      {(hasFindingsCount || hasComment) && (
        <ViewWithSeparators
          horizontal
          style={{
            marginLeft: theme.padding,
            alignItems: 'center',
          }}
          separatorMargin={theme.padding / 2}
        >
          {hasFindingsCount && (
            <CountChips
              questions={0}
              checklists={0}
              checklistsCompleted={0}
              questionsCompleted={0}
              actions={actionsCount}
              controls={controlsCount}
              unreviewedActions={unreviewedActionsCount}
              unreviewedControls={unreviewedControlsCount}
            />
          )}
          {hasComment && (
            <View
              style={{
                minWidth: 33,
                paddingVertical: 1,
                alignItems: 'center',
              }}
            >
              <Icon
                source={ICONS.CommentLight}
                color={theme.colors.fieldValueText}
              />
            </View>
          )}
        </ViewWithSeparators>
      )}
    </CardRow>
  );
};
